module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-up.ea82635a.svg";